import styles from '@/styles/nav-tab-glass.module.css'
import { cn } from '@/lib/utils'

/** 顶部导航 Tab 发光毛玻璃样式（Header / AdminHeader / OemAdminHeader 共用） */
export function navTabClass(...classes: (string | undefined)[]) {
  return cn(styles.tab, ...classes)
}
